const KeenSlider = window.KeenSlider

const { breakpoints } = window.BAO.MediaBreakpoints
const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins
const { getElement } = window.BAO.Utils

class HeaderSearchDropdown extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.eventBus = window.theme.nosto.eventBus
    this.events = window.theme.autocomplete.events
    this.config = window.theme.autocomplete.config

    this.lastResponse = null
    this.initialViewRendered = false
    this.cardCache = new Map()
  }

  connectedCallback () {
    super.connectedCallback()

    this.initialViewCarousel = this.setInitialViewCarousel()
    this.subscribeToEvents()

    this.handleResize()

    const snapshot = window.theme.autocomplete.stateLayer?.state

    if (snapshot) {
      this.handleResponseUpdated(snapshot)
    }
  }

  setupListeners () {
    super.setupListeners()

    // Resize events
    this.handleResize = this.handleResize.bind(this)

    this.debouncedResize = window.BAO.Utils.debounce((event) => {
      this.handleResize(event)
    }, this.config.debounceMs)

    this.listeners.add(window, 'resize', this.debouncedResize)

    // Input and form events
    this.debouncedHandleInput = window.BAO.Utils.debounce((event) => {
      this.handleInput(event)
    }, this.config.debounceMs)

    this.listeners.add(
      this.externalEls.mobileInput.element,
      'input',
      this.debouncedHandleInput,
    )

    this.listeners.add(
      this.externalEls.desktopInput.element,
      'input',
      this.debouncedHandleInput,
    )

    this.listeners.add(
      this.externalEls.form.element,
      'submit',
      this.handleSubmit.bind(this),
    )

    // Click events
    this.listeners.add(
      this.els.resultsKeywordsTemplate.element,
      'click',
      this.handleKeywordClick.bind(this),
    )

    this.listeners.add(
      this.els.resultsProducts.element,
      'click',
      this.handleProductCardClick.bind(this),
    )

    // Toggle events
    this.els.toggle?.elements.forEach((toggleEl) => {
      this.listeners.add(toggleEl, 'click', this.handleToggle.bind(this))
    })
  }

  subscribeToEvents () {
    this.eventBus.subscribe(
      this.events.STATE.RESPONSE_UPDATED,
      this.handleResponseUpdated.bind(this),
    )

    document.addEventListener(
      'drawer-changed',
      this.handleDrawerChange.bind(this),
    )
  }

  setInitialViewCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.7,
          spacing: 1,
        },
        breakpoints: {
          [`(min-width: ${breakpoints.sm}px)`]: {
            slides: {
              perView: 2.2,
              spacing: 1,
            },
          },
          [`(min-width: ${breakpoints.lg}px)`]: {
            disabled: true,
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }

  handleResize () {
    if (window.BAO.MediaBreakpoints.isLg) {
      this.externalEls.dialog.element.setAttribute('popover', 'auto')
      return
    }

    this.externalEls.dialog.element.removeAttribute('popover')
  }

  handleInput (event) {
    // this.els.input.element.value = event.target.value
    this.externalEls.mobileInput.element.value = event.target.value
    this.externalEls.desktopInput.element.value = event.target.value

    const query = event.target.value.trim()
    if (query === this.lastResponse.activeTerm) return
    this.query = query
    this.eventBus.publish(this.events.UI.QUERY_UPDATED, { query })
  }

  handleSubmit (event) {
    if (this.lastResponse?.fetching || !this.lastResponse?.activeTerm) {
      event.preventDefault()
      return
    }

    this.eventBus.publish(this.events.TRACKING.SUBMIT_SEARCH, {
      query: this.query,
    })

    if (!this.lastResponse.redirect) return

    event.preventDefault()
    window.location.href = this.lastResponse.redirect
  }

  handleKeywordClick (event) {
    if (!event.target.closest('.hd-SearchDropdown_Link')) return

    const response = this.lastResponse
    if (!response) return

    this.eventBus.publish(this.events.TRACKING.KEYWORD_CLICKED, {
      request: { query: response.activeTerm },
      results: response.products,
    })
  }

  handleProductCardClick (event) {
    const productCard = event.target.closest('.prd-Card')
    const url = productCard?.dataset.productUrl || false
    if (!productCard || !url) return

    this.eventBus.publish(this.events.TRACKING.PRODUCT_CLICKED, {
      productId: productCard.dataset.productId,
      productUrl: productCard.dataset.productUrl,
    })
  }

  handleToggle (event) {
    const target = event.target
    const type = target.dataset.type

    this.els.toggle.elements.forEach((toggleEl) => {
      if (toggleEl.dataset.type === type) {
        toggleEl.setAttribute('aria-expanded', true)
        return
      }

      toggleEl.setAttribute('aria-expanded', false)
    })

    this.els.toggleTemplate.elements.forEach((templateEl) => {
      if (templateEl.dataset.type === type) {
        templateEl.setAttribute('aria-hidden', false)
        return
      }

      templateEl.setAttribute('aria-hidden', true)
    })
  }

  handleDrawerChange () {
    if (window.drawers.activeDrawerKey === 'search') {
      setTimeout(() => {
        if (window.BAO.MediaBreakpoints.isLg) {
          this.externalEls.desktopInput.element.focus()
        } else {
          this.externalEls.mobileInput.element.focus()
        }
      }, 500)

      return
    }

    setTimeout(() => {
      this.externalEls.mobileInput.element.value = ''
      this.externalEls.desktopInput.element.value = ''
      this.query = ''
      this.eventBus.publish(this.events.UI.QUERY_UPDATED, { query: '' })
    }, 500)
  }

  async handleResponseUpdated (response) {
    this.lastResponse = response
    const view = this.pickView(response)

    if (response.activeTerm && window.drawers?.activeDrawerKey !== 'search') {
      const siteDrawers = getElement('site-drawers')
      siteDrawers.open('search')
    }

    switch (view) {
      case 'initial':
        this.renderSearches(response.popularSearches, response.recentSearches)
        break

      case 'results':
        await this.renderProducts(response.products, response.activeTerm)
        this.renderKeywords(response.keywords)
        this.renderCategories(response.categories)
        break

      case 'no-results':
        this.renderNoResults(response.activeTerm)
        break

      case 'redirect':
        this.renderRedirect(response.redirect)
        break
    }

    this.setView(view)
  }

  pickView (response) {
    if (response.fetching) return 'initial'

    const hasTerm = response.activeTerm?.length > 1
    const hasHits = response.products?.hits?.length > 0
    const hasRedirect = response.redirect

    if (hasTerm && hasHits) return 'results'
    if (hasTerm && hasRedirect && !hasHits) return 'redirect'
    if (hasTerm && !hasHits) return 'no-results'

    return 'initial'
  }

  setView (view) {
    const views = {
      initial: this.els.initialView.element,
      results: this.els.resultsView.element,
      'no-results': this.els.noResultsView.element,
      redirect: this.els.redirectView.element,
    }

    Object.entries(views).forEach(([name, element]) => {
      if (name === view) {
        element.removeAttribute('hidden')
      } else {
        element.setAttribute('hidden', '')
      }
    })
  }

  renderSearches (popular, recent) {
    if (this.initialViewRendered) return

    if (popular.length) {
      this.els.initialPopularSearches.element.removeAttribute('hidden')
      this.els.initialPopularSearchesTemplate.element.innerHTML =
        this.templateKeywords(popular)
    } else {
      this.els.initialPopularSearches.element.setAttribute('hidden', '')
      this.els.initialPopularSearchesTemplate.element.innerHTML = ''
    }

    if (recent.length) {
      this.els.initialRecentSearches.element.removeAttribute('hidden')
      this.els.initialRecentSearchesTemplate.element.innerHTML =
        this.templateKeywords(recent)
    } else {
      this.els.initialRecentSearches.element.setAttribute('hidden', '')
      this.els.initialRecentSearchesTemplate.element.innerHTML = ''
    }

    this.initialViewRendered = true
  }

  renderProducts (products, query) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      // Update URL
      this.els.resultsProductsLink.element.setAttribute(
        'href',
        `/search?q=${encodeURIComponent(query)}`,
      )

      // Update count
      const titleEl = this.els.resultsProductsTitle.element
      const productsTotal = window.BAO.Utils.formatMoney(
        products.total * 100,
        '{{amount_no_decimals}}',
      )
      const string = titleEl.dataset.format.replaceAll(
        '[count]',
        productsTotal,
      )
      titleEl.textContent = string

      // Update product cards
      const list = this.els.resultsProductsTemplate.element

      const htmlList = await Promise.all(
        products.hits.map(async (product) => {
          if (!product.url) return ''

          let url = new URL(product.url)
          url = url.pathname

          if (!url.startsWith(window.Shopify.routes.root)) {
            url = `${window.Shopify.routes.root}${url}`
          }

          let articleHtml = this.cardCache.get(product.url)

          if (!articleHtml) {
            try {
              const sectionHtml = await window.BAO.sectionRenderer.fetchSingle(
                'nosto-product-card',
                url,
              )

              const sectionDocument =
                window.BAO.sectionRenderer.convertToDOM(sectionHtml)
              const articleElement = sectionDocument.querySelector('.prd-Card')
              articleElement.setAttribute('data-nosto-type', 'autocomplete')
              articleHtml = articleElement ? articleElement.outerHTML : ''

              this.cardCache.set(url, articleHtml)
            } catch (error) {
              console.error('Failed to load product card', error)
              return ''
            }
          }

          if (!articleHtml) return ''

          return `
            <div class="hd-SearchDropdown_ResultsItem">
              ${articleHtml}
            </div>
          `
        }),
      )

      list.innerHTML = htmlList.join('')
      resolve()
    })
  }

  renderKeywords (keywords) {
    const titleEl = this.els.toggle.elements.find(
      (el) => el.dataset.type === 'keywords',
    )
    const templateEl = this.els.toggleTemplate.elements.find(
      (el) => el.dataset.type === 'keywords',
    )

    if (!keywords.hits?.length) {
      titleEl.setAttribute('hidden', '')
      templateEl.setAttribute('hidden', '')
      templateEl.innerHTML = ''
      return
    }

    titleEl.removeAttribute('hidden')
    templateEl.removeAttribute('hidden')
    templateEl.innerHTML = this.templateKeywords(keywords.hits)
  }

  renderCategories (categories) {
    const titleEl = this.els.toggle.elements.find(
      (el) => el.dataset.type === 'categories',
    )
    const templateEl = this.els.toggleTemplate.elements.find(
      (el) => el.dataset.type === 'categories',
    )

    if (!categories.length) {
      titleEl.setAttribute('hidden', '')
      templateEl.setAttribute('hidden', '')
      templateEl.innerHTML = ''
      return
    }

    titleEl.removeAttribute('hidden')
    templateEl.removeAttribute('hidden')
    templateEl.innerHTML = this.templateCategories(categories)
  }

  renderNoResults (query) {
    const titleEl = this.els.noResultsTitle.element
    const string = titleEl.dataset.format.replaceAll('[query]', query)
    titleEl.innerHTML = string
  }

  renderRedirect (url) {
    this.els.redirectTitle.element.href = url
  }

  escapeHtml (str) {
    return String(str ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  }

  templateKeywords (keywords) {
    return keywords
      .map((object) => {
        const keyword = object.query || object.keyword

        return `
          <li class="hd-SearchDropdown_ListItem">
            <a
              class="hd-SearchDropdown_Link fz-14_140"
              href="${window.routes.searchUrl}?q=${encodeURIComponent(keyword)}"
            >
              ${this.escapeHtml(keyword)}
            </a>
          </li>
        `
      })
      .join('')
  }

  templateCategories (categories) {
    return categories
      .map((category) => {
        return `
          <li class="hd-SearchDropdown_ListItem">
            <a
              class="hd-SearchDropdown_Link fz-14_140"
              href="${window.routes.collectionsUrl}/${category.urlPath}"
            >
              ${this.escapeHtml(category.name)}
            </a>
          </li>
        `
      })
      .join('')
  }
}

if (!customElements.get('header-search-dropdown')) {
  customElements.define('header-search-dropdown', HeaderSearchDropdown)
}
